'use es6';

import { PureComponent, Fragment } from 'react';
import FormFieldMinMaxConfigurationFieldInput from 'FormsUI/components/editor/form/configuration/FormFieldMinMaxConfigurationFieldInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { StepperInput } from 'foundations-components/transitional/components/StepperInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getObjectTypeIdValue } from 'FormsCommonComponents/form-definition/utils/FormFieldUtils';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import { CommentableArea } from 'collaboration-sidebar';
import updateFormFieldKey from 'forms-utils-lib/formField/utils/updateFormFieldKey';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import updateValidation from 'forms-utils-lib/formField/utils/updateValidation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = suffix => `editor.form.config.${suffix}`;
export default class NumberField extends PureComponent {
  renderValidationField() {
    const {
      field,
      update
    } = this.props;
    const objectTypeId = getObjectTypeIdValue(field.objectTypeId, field.propertyObjectType);
    return /*#__PURE__*/_jsx(FormFieldMinMaxConfigurationFieldInput, {
      fieldType: field.fieldType,
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('setValueLimits')
      }),
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: langKey('numberToolTip')
      }),
      currentValue: field.validation.data,
      handleChange: newValue => update(updateValidation(field, {
        data: newValue
      })),
      field: field,
      fieldName: field.name,
      fieldObjectTypeId: objectTypeId,
      fieldPropertyObjectType: field.propertyObjectType
    });
  }
  renderDefaultValueField() {
    const {
      field,
      update
    } = this.props;
    return /*#__PURE__*/_jsx(CommentableArea, {
      moduleId: `${getPropertyObjectTypeId(field)}-default-value`,
      description: {
        translationKey: 'formsDefaultValue'
      },
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "config-input-field",
        children: /*#__PURE__*/_jsx(FormControl, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('defaultValue')
          }),
          tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
            message: langKey('defaultValueToolTip')
          }),
          tooltipPlacement: "top right",
          children: /*#__PURE__*/_jsx(StepperInput, {
            formatter: value => value,
            value: Number(field.defaultValue),
            use: "on-dark",
            onChange: ({
              target: {
                value
              }
            }) => update(updateFormFieldKey(field, FormFieldKeys.DEFAULT_VALUE, value)),
            "data-editable-field": "default-value"
          })
        })
      })
    });
  }
  render() {
    const {
      field,
      update
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.props.RequiredField, this.props.HiddenField, this.props.LabelField, this.props.HelpTextField, this.props.renderPlaceholderField({
        value: field.placeholder,
        update: newValue => update(updateFormFieldKey(field, FormFieldKeys.PLACEHOLDER, newValue)),
        field
      }), this.renderDefaultValueField(), this.renderValidationField(), this.props.ProfillingField]
    });
  }
}